<!--
 * @Author: cryi.liu
 * @Date: 2020-04-30 11:42:45
 * @LastEditTime: 2020-05-06 14:24:12
 * @Description: 原 PSS 风格页脚
 -->
<template>
  <footer class="pss__footer">
    <copyright />
    <statement />
  </footer>
</template>

<script>
import Copyright from './Copyright.vue';
import Statement from './Statement.vue';

export default {
  name: 'PssFooter',
  components: {
    Copyright,
    Statement,
  },
};
</script>

<style lang="less" scoped>
.pss__footer {
  text-align: center;
  font-size: 12px;
  color: #616963;
  line-height: 18px;
}
</style>
